import React, { useCallback, useState } from "react";
import { api } from "../../util/api";
import { DetailedErrorAlert } from "../DetailedErrorAlert";
import { RemotePaginateSelector } from "./RemotePaginateSelector";

const TEST_MAPPING_URL = "/tests/test_mappings.json";
const TEST_MAPPING_BY_IDS = "/tests/test_mappings_by_identifiers.json";

export const TestSelector = ({ resourceUrl, valueSelector = "id", labelSelector = "name", labIds = [], allTests, ...rest }) => {
  const [error, setError] = useState(null);

  const loadDefaultOptions = useCallback(async () => {
    if (!rest.value) {
      return [];
    }

    try {
      const res = await api.get(TEST_MAPPING_BY_IDS, { params: { id: rest.value } });
      return res.data.resources.map((p) => ({ value: p[valueSelector], label: p[labelSelector] }));
    } catch (err) {
      console.error("Failed to fetch default options for test selector:", err);
      setError(err);
      return [];
    }
  }, [labelSelector, valueSelector, rest.value]);

  return (
    <>
      <DetailedErrorAlert error={error} message="There was an error while fetching Tests" />

      <RemotePaginateSelector
        {...rest}
        resourceUrl={resourceUrl ? resourceUrl : TEST_MAPPING_URL}
        key={labIds.toString()}
        valueKey={valueSelector}
        labelKey={labelSelector}
        loadDefaultOptions={rest.value ? loadDefaultOptions : undefined}
        dataKey="resources"
        extraParams={{ lab_ids: labIds, all_tests: allTests }}
      />
    </>
  );
};
